import { render } from "./Placeholder.vue?vue&type=template&id=1f41728f&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"

import "./Placeholder.vue?vue&type=style&index=0&id=1f41728f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f41728f"]])

export default __exports__